import { CurrentRfqStatusThemeSizeConfig } from './types';

const large: CurrentRfqStatusThemeSizeConfig = {
  currentRfqStatus: {},
};

export default large;
